import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const styles = {
  shell: { display: 'flex', minHeight: '100vh' },
  sidebar: {
    width: 220, background: '#1a1a2e', color: '#fff',
    display: 'flex', flexDirection: 'column', padding: '24px 0',
  },
  brand: { padding: '0 24px 32px', fontSize: 16, fontWeight: 700, color: '#7c83fd', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 4 },
  nav: { flex: 1 },
  link: {
    display: 'block', padding: '12px 24px', color: '#ccc',
    textDecoration: 'none', fontSize: 14,
  },
  activeLink: {
    color: '#fff', background: 'rgba(124,131,253,0.2)',
    borderLeft: '3px solid #7c83fd',
  },
  userBar: { padding: '16px 24px', borderTop: '1px solid #333', fontSize: 13, color: '#aaa' },
  logoutBtn: {
    marginTop: 8, background: 'none', border: '1px solid #555',
    color: '#aaa', padding: '6px 12px', borderRadius: 4, cursor: 'pointer', width: '100%',
  },
  main: { flex: 1, padding: 32, overflowY: 'auto', background: '#f5f7fa' },
};

const navLink = ({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) });

export default function Layout() {
  const { user, logout, isRole } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };

  const logoSrc = user?.logoBase64
    ? `data:${user.logoContentType || 'image/png'};base64,${user.logoBase64}`
    : null;

  return (
    <div style={styles.shell}>
      <aside style={styles.sidebar}>
        <div style={styles.brand}>
          {logoSrc
            ? <img src={logoSrc} alt={user?.tenantCode} style={{ width: 48, height: 48, borderRadius: 8, objectFit: 'contain', marginBottom: 8, display: 'block' }} />
            : <span>🔐</span>
          }
          <span>{user?.tenantCode || 'SecureOffer'}</span>
        </div>
        <nav style={styles.nav}>
          <NavLink to="/dashboard" style={navLink}>📊 Dashboard</NavLink>

          {isRole('RECRUITER', 'TENANT_ADMIN', 'SUPER_ADMIN') && (
            <NavLink to="/candidates" style={navLink}>👤 Candidates</NavLink>
          )}

          {isRole('RECRUITER', 'TENANT_ADMIN', 'SUPER_ADMIN') && (
            <NavLink to="/offers/create" style={navLink}>✉️ Create Offer</NavLink>
          )}

          {isRole('TENANT_ADMIN', 'SUPER_ADMIN') && (
            <NavLink to="/users" style={navLink}>👥 Users</NavLink>
          )}

          {isRole('TENANT_ADMIN', 'SUPER_ADMIN') && (
            <NavLink to="/audit" style={navLink}>📋 Audit Logs</NavLink>
          )}

          {isRole('TENANT_ADMIN', 'SUPER_ADMIN') && (
            <NavLink to="/settings" style={navLink}>⚙️ Settings</NavLink>
          )}
        </nav>
        <div style={styles.userBar}>
          <div style={{ fontWeight: 600, color: '#fff' }}>{user?.email}</div>
          <div style={{ fontSize: 11, color: '#7c83fd', marginTop: 2 }}>{user?.role}</div>
          <button style={styles.logoutBtn} onClick={handleLogout}>Logout</button>
        </div>
      </aside>
      <main style={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
